// Saisonale Farbauswahl - außerhalb aller anderen Funktionen
function getSeasonalColors() {
  var currentMonth = new Date().getMonth() + 1;
  
  // Herbstfarben (September-November)
  if (currentMonth >= 9 && currentMonth <= 11) {
    return [
      { bg1: '#F5E6D3', bg2: '#E8D5B7' }, // Sanftes Beige
      { bg1: '#F0E68C', bg2: '#DDD26A' }, // Zartes Goldgelb
      { bg1: '#DEB887', bg2: '#D2B48C' }, // Helles Sandbraun
      { bg1: '#F4A460', bg2: '#E6967A' }, // Sanftes Orange
      { bg1: '#BC8F8F', bg2: '#A0808A' }, // Rosiges Braun
      { bg1: '#D3D3D3', bg2: '#C0C0C0' }, // Warmes Grau
      { bg1: '#F5DEB3', bg2: '#DDD0A7' }  // Weizenbeige
    ];
  }
  
  // Winterfarben (Dezember-Februar)
  if (currentMonth === 12 || currentMonth <= 2) {
    return [
      { bg1: '#E6F3FF', bg2: '#B3D9FF' }, // Sanftes Eisblau
      { bg1: '#F0F8FF', bg2: '#E0E6FF' }, // Schneeweiß
      { bg1: '#E6E6FA', bg2: '#D8BFD8' }, // Winterviolett
      { bg1: '#F5F5DC', bg2: '#E6E6DC' }, // Warmes Beige
      { bg1: '#FFE4E1', bg2: '#FFC0CB' }, // Zartrosa
      { bg1: '#F0FFFF', bg2: '#E0F6FF' }, // Azurblau
      { bg1: '#FFFACD', bg2: '#F5DEB3' }  // Cremeweiß
    ];
  }
  
  // Standard-Farben (März-August)
  return [
    { bg1: '#B8C6DB', bg2: '#8DA9D4' }, // Blau
    { bg1: '#8A98E2', bg2: '#7A7FD3' }, // Lila
    { bg1: '#87DFBA', bg2: '#5ECDA9' }, // Türkis
    { bg1: '#FFA9C6', bg2: '#FF85B3' }, // Pink
    { bg1: '#A0E7E5', bg2: '#7BDFF2' }, // Mint
    { bg1: '#FFD4B8', bg2: '#FFA987' }, // Pfirsich
    { bg1: '#D4BBFC', bg2: '#B69CFF' }  // Lavendel
  ];
}

// Funktion für schwebende Herbstblätter - subtilere Version
function createFloatingAutumnLeaves() {
  var currentMonth = new Date().getMonth() + 1;
  
  // Nur im Herbst anzeigen (September-November)
  if (currentMonth < 9 || currentMonth > 11) {
    return;
  }
  
  // CSS für schwebende Herbstblätter hinzufügen
  var style = document.createElement('style');
  style.id = 'autumn-leaves-style';
  style.textContent = 
    '.autumn-leaves-container {' +
      'position: fixed;' +
      'top: 0;' +
      'left: 0;' +
      'width: 100%;' +
      'height: 100%;' +
      'pointer-events: none;' +
      'z-index: 1;' +
      'overflow: hidden;' +
    '}' +
    '.autumn-leaf {' +
      'position: absolute;' +
      'font-size: 18px;' +
      'color: #D2691E;' +
      'animation: floatDown 12s linear infinite;' +
      'opacity: 0.5;' +
    '}' +
    '.autumn-leaf:nth-child(2n) { animation-duration: 15s; color: #CD853F; }' +
    '.autumn-leaf:nth-child(3n) { animation-duration: 18s; color: #DAA520; }' +
    '.autumn-leaf:nth-child(4n) { animation-duration: 14s; color: #B22222; }' +
    '.autumn-leaf:nth-child(5n) { animation-duration: 16s; color: #A0522D; }' +
    '@keyframes floatDown {' +
      '0% {' +
        'transform: translateY(-100px) rotate(0deg);' +
        'opacity: 0;' +
      '}' +
      '15% {' +
        'opacity: 0.5;' +
      '}' +
      '85% {' +
        'opacity: 0.5;' +
      '}' +
      '100% {' +
        'transform: translateY(calc(100vh + 100px)) rotate(360deg);' +
        'opacity: 0;' +
      '}' +
    '}';
  
  document.head.appendChild(style);
  
  // Container für Herbstblätter erstellen
  var leavesContainer = document.createElement('div');
  leavesContainer.className = 'autumn-leaves-container';
  leavesContainer.id = 'autumn-leaves';
  document.body.appendChild(leavesContainer);
  
  var leafEmojis = ['🍂', '🍁', '🍃'];
  var isAnimating = false;
  
  // Funktion zum Erstellen eines Blattes
  function createLeaf() {
    var leaf = document.createElement('div');
    leaf.className = 'autumn-leaf';
    leaf.textContent = leafEmojis[Math.floor(Math.random() * leafEmojis.length)];
    leaf.style.left = Math.random() * 100 + '%';
    leaf.style.animationDelay = Math.random() * 3 + 's';
    
    leavesContainer.appendChild(leaf);
    
    // Blatt nach Animation entfernen
    setTimeout(function() {
      if (leaf.parentNode) {
        leaf.parentNode.removeChild(leaf);
      }
    }, 18000);
  }
  
  // Funktion für eine Blätter-Sequenz
  function startLeafSequence() {
    if (isAnimating) return;
    
    isAnimating = true;
    
    // 3-5 Blätter in kurzen Abständen erstellen
    var leafCount = Math.floor(Math.random() * 3) + 3; // 3-5 Blätter
    
    for (var i = 0; i < leafCount; i++) {
      setTimeout(createLeaf, i * 800); // Alle 0.8 Sekunden ein Blatt
    }
    
    // Nach der Sequenz eine längere Pause
    setTimeout(function() {
      isAnimating = false;
    }, leafCount * 800 + 5000); // 5 Sekunden Pause nach der letzten Blatt-Erstellung
  }
  
  // Erste Sequenz nach 2 Sekunden starten
  setTimeout(startLeafSequence, 2000);
  
  // Alle 15-25 Sekunden eine neue Sequenz starten
  setInterval(function() {
    if (!isAnimating) {
      setTimeout(startLeafSequence, Math.random() * 10000); // Zufällige Verzögerung 0-10s
    }
  }, 20000); // Alle 20 Sekunden prüfen
}


// Funktion zur Anwendung der Farben auf Produktkarten
function applyColorsToProductCards(container) {
  var productCards = container.querySelectorAll('.product-card, .product-card-horizontal, .product-card-vertical');
  
  if (productCards.length === 0 && container.classList && (container.classList.contains('product-card') || container.classList.contains('product-card-horizontal'))) {
    productCards = [container];
  }
  
  var existingCards = document.querySelectorAll('.product-card[data-color-applied="true"], .product-card-horizontal[data-color-applied="true"]');
  var startIndex = existingCards.length;
  
  var colors = getSeasonalColors();
  
  productCards.forEach(function(card, index) {
    if (card.hasAttribute('data-color-applied')) {
      return;
    }
    
    var globalIndex = startIndex + index;
    var colorIndex = globalIndex % colors.length;
    var color = colors[colorIndex];
    
    card.style.background = 'linear-gradient(135deg, ' + color.bg1 + ', ' + color.bg2 + ')';
    card.style.color = 'white';
    card.style.borderRadius = '8px';
    card.style.boxShadow = '0 4px 8px rgba(0,0,0,0.1)';
    card.style.padding = '15px';
    card.style.transition = 'transform 0.3s ease';
    
    card.addEventListener('mouseenter', function() {
      this.style.transform = 'translateY(-5px)';
      this.style.boxShadow = '0 8px 16px rgba(0,0,0,0.2)';
    });
    
    card.addEventListener('mouseleave', function() {
      this.style.transform = 'translateY(0)';
      this.style.boxShadow = '0 4px 8px rgba(0,0,0,0.1)';
    });
    
    var titles = card.querySelectorAll('h3, .midi-title, .product-title-horizontal');
    titles.forEach(function(title) {
      title.style.color = '#333333';
      title.style.fontWeight = 'bold';
    });
    
    var descriptions = card.querySelectorAll('.midi-description, .product-artist');
    descriptions.forEach(function(desc) {
      desc.style.color = '#444444';
    });
    
    var prices = card.querySelectorAll('.midi-price, .product-price-horizontal .price');
    prices.forEach(function(price) {
      price.style.fontWeight = 'bold';
      price.style.fontSize = '1.2em';
      price.style.marginTop = '10px';
      price.style.color = '#333333';
    });
    
    card.setAttribute('data-color-applied', 'true');
  });
}

// Initiale Anwendung beim Laden der Seite
document.addEventListener('DOMContentLoaded', function() {
  applyColorsToProductCards(document);
  
  // Schwebende Herbstblätter aktivieren
  createFloatingAutumnLeaves();
  
  // MutationObserver einrichten
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1) {
          if (node.classList && (node.classList.contains('product-card') || node.classList.contains('product-card-horizontal'))) {
            applyColorsToProductCards(node);
          } else {
            applyColorsToProductCards(node);
          }
        }
      });
    });
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  
  document.addEventListener('ajaxComplete', function(event) {
    setTimeout(function() {
      applyColorsToProductCards(document);
    }, 100);
  });
  
  if (typeof Shopify !== 'undefined') {
    if (typeof Shopify.theme !== 'undefined' && typeof Shopify.theme.on === 'function') {
      Shopify.theme.on('section:load', function(event) {
        applyColorsToProductCards(event.target);
      });
    }
  }
  
  var loadMoreButtons = document.querySelectorAll('.load-more, .view-more, .pagination__load-more');
  loadMoreButtons.forEach(function(button) {
    button.addEventListener('click', function() {
      setTimeout(function() {
        applyColorsToProductCards(document);
      }, 1000);
    });
  });
});

// Farbverlauf für den aktuellen Bereich erstellen
document.addEventListener('DOMContentLoaded', function() {
  var element = document.querySelector('.collection-links__container');
  
  if (element) {
    element.style.background = 'linear-gradient(to top, #8A98E2 0%, #7A7FD3)';
  }
});
